<template>
    <div class="question-form">
        <b-form data-vv-scope="question-form">
            <b-form-group
                label="Soal"
                label-for="soal"
                label-cols-sm="3"
                label-align-sm="left"
            >
            <!-- <ckeditor 
                @namespaceloaded="onNamespaceLoaded" 
                :config="editorConfig" 
                id="soal"
                name="soal"
                data-vv-as="Soal"
                v-model="question_form.question"
                v-validate="'required'"
                autocomplete="off">
            </ckeditor> -->
        
            <wysiwyg
                id="soal"
                name="soal"
                data-vv-as="Soal"
                v-model="question_form.question"
                type="text"
                v-validate="'required'"
                autocomplete="off"
            />
                <span :class="{ 'error-validation': errors.first('question-form.soal') }">{{ errors.first('question-form.soal') }}</span>
            </b-form-group>
            <b-form-group
                    label="Perlu upload file ?"
                    label-for="published"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                <b-form-radio-group
                    id="materi-publish"
                    name="materi_publish"
                    v-model="question_form.is_file"
                    :options="options"
                    class=""
                    value-field="item"
                    text-field="name"
                    disabled-field="notEnabled"
                ></b-form-radio-group>
                <span :class="{ 'error-validation': errors.first('question-form.materi_publish') }">{{ errors.first('question-form.materi_publish') }}</span>
            </b-form-group>
            <b-form-group
                v-if="question_form.is_file==1"
                label="Input Link"
                label-for="Input Link"
                label-cols-sm="3"
                label-align-sm="left"
            >
                <b-form-input v-model="question_form.file_path" v-validate="'required'"></b-form-input>
                <span :class="{ 'error-validation': errors.first('question-form.file_path') }">{{ errors.first('question-form.file_path') }}</span>
            </b-form-group>
            <hr>
            <div class="card">
                <div class="card-header" style="background: #ca062a; color: white;">
                    <h5 style="color: white;">Jawaban</h5>
                </div>
                <div class="card-body p-0" style="border: none;">
                    <div class="card answer-section" v-for="(question, index) in question_form.options" :key="index">
                        <div class="card-body">
                            <a class="btn btn-danger btn-sm" style="position: absolute; top: 4px; right: 4px; z-index: 1;" @click="removeChoice(index)"><i class="fa fa-times"></i></a>
                            <b-form-group
                                :label="'Pilihan '+(index+1)"
                                label-for="Pilihan"
                                label-cols-sm="3"
                                label-align-sm="left"
                                class="m-0"
                            >
                                <div>
                                    <wysiwyg
                                        :id="'choice-'+index"
                                        :name="'choice-'+index"
                                        :data-vv-as="'Jawaban pilihan '+(index+1)"
                                        v-model="question.choice"
                                        type="text"
                                        class="table-responsive"
                                        v-validate="'required'"
                                        autocomplete="off"
                                    />
                                    <span :class="{ 'error-validation': errors.first('question-form.'+'choice-'+index) }">{{ errors.first('question-form.'+'choice-'+index) }}</span>
                                    <b-form-group
                                            label="upload file ?"
                                            label-for="published"
                                            label-cols-sm="3"
                                            label-align-sm="left"
                                        >
                                        <b-form-radio-group
                                            :id="'choice-is_file-'+index"
                                            :name="'choice-is_file-'+index"
                                            v-model="question.is_file"
                                            :options="options"
                                            class=""
                                            value-field="item"
                                            text-field="name"
                                            disabled-field="notEnabled"
                                        ></b-form-radio-group>
                                        <span :class="{ 'error-validation': errors.first('question-form.materi_publish') }">{{ errors.first('question-form.materi_publish') }}</span>
                                    </b-form-group>
                                    <b-form-group
                                        v-if="question.is_file==1"
                                        label="Input Link"
                                        label-for="Input Link"
                                        label-cols-sm="3"
                                        label-align-sm="left"
                                    >
                                        <b-form-input 
                                            v-model="question.file_path" 
                                            v-validate="'required'"></b-form-input>
                                        <span :class="{ 'error-validation': errors.first('question-form.file_path') }">{{ errors.first('question-form.file_path') }}</span>
                                    </b-form-group>
                                </div>
                                <div>
                                    <b-form-group
                                        label="Atur Jawaban Benar"
                                        label-for="answer-true"
                                        label-cols-sm="4"
                                        label-align-sm="left"
                                        class="correct-answer-section m-0"
                                    >
                                        <b-form-radio-group
                                            :id="'answer-true-'+index"
                                            :name="'answer-true-'+index"
                                            v-model="question.is_answer"
                                            :options="options"
                                            class="mb-3"
                                            data-vv-as="Jawaban benar"
                                            value-field="item"
                                            text-field="name"
                                            v-validate="''"
                                            disabled-field="notEnabled"
                                            :disabled="question.is_answer == '1' ? !isSelected : isSelected"
                                        ></b-form-radio-group>
                                        <!-- <span :class="{ 'error-validation': errors.first('question-form.'+'answer-true-'+index) }">{{ errors.first('question-form.'+'answer-true-'+index) }}</span> -->
                                    </b-form-group>
                                </div>
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
            <div class="my-2 d-flex align-items-center">
                <a href="#!" @click.prevent="addChoice()" class="btn btn-success" style="border-radius:30px"><i class="fa fa-plus"></i> Tambah Jawaban Pilihan</a>
            </div>
        </b-form>
        <hr class="m-0">
        <div class="form-footer d-flex justify-content-end mt-3">
            <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
            <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideQuestionFormModal">BATAL</b-button>
            <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveQuestion">SIMPAN</b-button>
        </div>
    </div>
</template>
<script src="../../../../node_modules/ckeditor4-vue/dist/ckeditor.js"></script>
<script>
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    import { EventBus } from '@/eventBus.js'
    export default {
        props: {
            quizId: {
                type: String,
                default: null
            },
            questionId: {
                type: String,
                default: null
            },
            questionDetail: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                editorConfig: {
                    extraPlugins: 'ckeditor_wiris',
                    removeButtons: 'Maximize,Image,Link,Anchor,About'
                },
                showLoader: false,
                isSelected: true,
                question_form: {
                    quiz_id: this.quizId,
                    is_file: this.questionId&&this.questionDetail.file_path ? 1 : 0,
                    file_path: this.questionId&&this.questionDetail.file_path ? this.questionDetail.file_path : '',
                    question: this.questionId ? this.questionDetail.question : null,
                    options: this.questionId ? this.questionDetail.options : [
                        {
                            choice: null,
                            is_answer: '1',
                            is_file: 0,
                        },
                        {   
                            choice: null,is_answer: '0',is_file: 0
                            }
                        ]
                },
                options: [
                    { item: '1', name: 'Ya' },
                    { item: '0', name: 'Tidak' },
                ]
            };
        },
        watch: {
            'question_form.options': {
                deep: true,
                handler(newVal) {
                    this.isSelected = false
                    newVal.forEach(element => {
                        if (element.is_answer == '1') {
                            this.isSelected = true
                        }
                    });
                }
            }
            
        },
        methods: {
            onNamespaceLoaded( CKEDITOR ) {
                CKEDITOR.plugins.addExternal(
                    'ckeditor_wiris',
                    '/mathtype-ckeditor4/',
                    'plugin.js'
                );
            },
            resetQuestionForm() {
                this.$validator.reset()
            },
            hideQuestionFormModal() {
                EventBus.$emit('hideQuestionFormModal', true)
                this.resetQuestionForm()
            },
            addChoice() {
                this.question_form.options.push({
                    choice: null,
                    is_answer: '0'
                })
            },
            removeChoice(index) {
                if (this.question_form.options.length <= 2) {
					this.$swal.fire('Peringatan!', 'Jawaban pilihan tidak bisa kurang dari dua', 'warning')
                } else {
                    this.question_form.options.splice(index, 1)
                }
            },
            async saveQuestion() {
                let scope = 'question-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        if (!this.isSelected) {
                            this.$swal.fire('Peringatan!', 'Jawaban benar belum terisi', 'warning')
                        } else {
                            if (this.questionId) {
                                this.question_form.id = this.questionId
                                this.updateQuestion(scope)
                            } else {
                                this.addQuestion(scope)
                            }
                        }
                    }
                });
            },
            async addQuestion(scope) {
                this.showLoader = true
                let form = this.question_form
                this.$store.dispatch('addQuestion', form)
                    .then((res) => {
                        this.showLoader = false
                        let quizId = this.quizId
                        this.$store.dispatch('getQuestionOverview', { quizId })
                        this.hideQuestionFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            },
            async updateQuestion(scope) {
                this.showLoader = true
                let form = this.question_form
                this.$store.dispatch('updateQuestion', form)
                    .then((res) => {
                        this.showLoader = false
                        let quizId = this.quizId
                        this.$store.dispatch('getQuestionOverview', { quizId })
                        this.hideQuestionFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            }
        }
    }
</script>
<style scoped>
.correct-answer-section div {
    padding-top: calc(.375rem + 1px);
    padding-bottom: calc(.375rem + 1px);
    padding-right: 5px;
    padding-left: 5px;
}
</style>